import React, { useState } from 'react';
import { FaExclamationCircle, FaShieldAlt } from 'react-icons/fa';
import PinInput from './PinInput';

const MfaLogin = ({ onVerify, onBack, error, loading, translations: t, username }) => {
  const [code, setCode] = useState('');

  const handleComplete = (completed) => {
    onVerify(completed);
  };

  const handleVerifyClick = () => {
    if (code.length === 6) onVerify(code);
  };

  return (
    <>
      <h2 className="login-welcome">{t.mfaTitle}</h2>
      <p className="login-subtitle">
        {t.mfaSubtitle.replace('{username}', username || '')}
      </p>

      {error && (
        <div className="error-message" role="alert">
          <FaExclamationCircle size={18} />
          <span>{error}</span>
        </div>
      )}

      <div className="form-group">
        {/* Reuse the PIN input UI for 6-digit codes */}
        <PinInput
          pin={code}
          setPin={setCode}
          onPinComplete={handleComplete}
        />
      </div>

      <button
        type="button"
        className="login-button-expanded"
        onClick={handleVerifyClick}
        disabled={loading || code.length !== 6}
        aria-label={t.mfaVerify}
      >
        {loading ? (
          <>
            <span className="spinner" />
            <span>{t.loggingIn}</span>
          </>
        ) : (
          <>
            <FaShieldAlt size={18} />
            <span>{t.mfaVerify}</span>
          </>
        )}
      </button>

      <a href="#" onClick={onBack} className="forgot-password">
        {t.mfaBack}
      </a>
    </>
  );
};

export default MfaLogin;
